/** Pays membres de l'UE + associés */
export const TED_COUNTRIES = [
  { code: 'AT', name: 'Autriche' },
  { code: 'BE', name: 'Belgique' },
  { code: 'BG', name: 'Bulgarie' },
  { code: 'CH', name: 'Suisse' },
  { code: 'CY', name: 'Chypre' },
  { code: 'CZ', name: 'Tchéquie' },
  { code: 'DE', name: 'Allemagne' },
  { code: 'DK', name: 'Danemark' },
  { code: 'EE', name: 'Estonie' },
  { code: 'ES', name: 'Espagne' },
  { code: 'FI', name: 'Finlande' },
  { code: 'FR', name: 'France' },
  { code: 'GR', name: 'Grèce' },
  { code: 'HR', name: 'Croatie' },
  { code: 'HU', name: 'Hongrie' },
  { code: 'IE', name: 'Irlande' },
  { code: 'IT', name: 'Italie' },
  { code: 'LT', name: 'Lituanie' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'LV', name: 'Lettonie' },
  { code: 'MT', name: 'Malte' },
  { code: 'NL', name: 'Pays-Bas' },
  { code: 'NO', name: 'Norvège' },
  { code: 'PL', name: 'Pologne' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RO', name: 'Roumanie' },
  { code: 'SE', name: 'Suède' },
  { code: 'SI', name: 'Slovénie' },
  { code: 'SK', name: 'Slovaquie' },
  { code: 'UK', name: 'Royaume-Uni' },
];

/** Types de documents TED */
export const TED_DOCUMENT_TYPES = [
  { value: 'contract_notice', label: 'Avis de marché' },
  { value: 'contract_award', label: "Avis d'attribution" },
  { value: 'prior_information', label: 'Information préalable' },
  { value: 'corrigendum', label: 'Rectificatif' },
];

/** Types de procédures TED */
export const TED_PROCEDURE_TYPES = [
  { value: 'open', label: 'Procédure ouverte' },
  { value: 'restricted', label: 'Procédure restreinte' },
  { value: 'negotiated', label: 'Procédure négociée' },
  { value: 'competitive_dialogue', label: 'Dialogue compétitif' },
  { value: 'innovation_partnership', label: "Partenariat d'innovation" },
];
